import React from 'react';

import AddRow from '../../../../common/controls/AddRow';
import AddButtons from './AddButtons';

const TopBar: React.FC<any> = (props: any) => {
  const { handleAddRequest, handleAddDiscomfort, disabled } = props;

  return (
    <AddRow
      label='Issues'
      buttons={
        <AddButtons
          disabled={disabled}
          handleAddRequest={handleAddRequest}
          handleAddDiscomfort={handleAddDiscomfort}
        />
      }
    />
  );
};

export default TopBar;
